import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import {
  Col,
  Row,
  ControlLabel,
  FormGroup
} from 'react-bootstrap';
import SelectComponent from './SelectComponent';
import { PRODUCTS } from './../helpers/build';
import ConditionalComponent from '../Components/ConditionalComponent';

export default class ReleaseMetricsSelectorComponent extends React.Component {
  static propTypes = {
    releaseMetricsInfo: PropTypes.shape({
      product: PropTypes.string.isRequired,
      case: PropTypes.string.isRequired,
      scenario: PropTypes.string.isRequired,
      sinceVersion: PropTypes.string
    }),
    availableCases: PropTypes.arrayOf(PropTypes.string).isRequired,
    availableScenarios: PropTypes.arrayOf(PropTypes.string).isRequired,
    availableVersions: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSelectorChange: PropTypes.func.isRequired
  };

  render() {
    const {
      releaseMetricsInfo,
      availableCases,
      availableScenarios,
      availableVersions,
      onSelectorChange
    } = this.props;

    const initialState = {
      case: releaseMetricsInfo.case,
      scenario: releaseMetricsInfo.scenario,
      product: releaseMetricsInfo.product,
      sinceVersion: releaseMetricsInfo.sinceVersion
    };

    return (
      <LocalForm
        id="metrics-selector-form"
        initialState={initialState}
        onChange={(model) => onSelectorChange(model)}
      >
        <FormGroup>
          <Row>
            <Col md={2}>
              <ControlLabel> Product </ControlLabel>
              <Control.custom
                id="product-select"
                model="."
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    noneOption: 'Select a product...',
                    options: [PRODUCTS.IEF_ENGINE, PRODUCTS.PROCESS, PRODUCTS.EXAMINE],
                    selected: modelValue.product,
                    onChange: v => {
                      const model = {
                        ...modelValue,
                        product: v,
                        sinceVersion: ''
                      };
                      onChange(model);
                    }
                  };
                }}
              />
            </Col>
            <Col md={2}>
              <ControlLabel> Since Version </ControlLabel>
              <Control.custom
                id="version-select"
                model=".sinceVersion"
                component={SelectComponent}
                className="form-control"
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    noneOption: 'Earliest Available',
                    options: availableVersions,
                    selected: modelValue,
                    onChange: v => onChange(v)
                  };
                }}
              />
            </Col>
            <Col md={3}>
              <Control.custom
                id="product-conditional"
                model="."
                component={ConditionalComponent}
                style={{ marginRight: '10px' }}
                mapProps={({ modelValue, onChange }) => {
                  return {
                    condition: modelValue.product !== PRODUCTS.EXAMINE,
                    children: <div>
                      <ControlLabel> Scenario </ControlLabel>
                      <SelectComponent
                        id="scenario-select"
                        className="form-control"
                        style={{ marginRight: '10px' }}
                        noneOption="Select a scenario..."
                        options={availableScenarios}
                        selected={modelValue.scenario}
                        onChange={(val) => {
                          const model = {
                            ...modelValue,
                            scenario: val
                          };
                          onChange(model);
                        }}
                      />
                    </div>,
                    elseChildren: <div>
                      <ControlLabel> Performance Case </ControlLabel>
                      <SelectComponent
                        id="case-select"
                        className="form-control"
                        style={{ marginRight: '10px' }}
                        noneOption="Select a case..."
                        options={availableCases}
                        selected={modelValue.case}
                        onChange={(val) => {
                          const model = {
                            ...modelValue,
                            case: val
                          };
                          onChange(model);
                        }}
                      />
                    </div>
                  };
                }}
              />
            </Col>
          </Row>
        </FormGroup>
      </LocalForm>
    );
  }
}


// WEBPACK FOOTER //
// src/Components/ReleaseMetricsSelectorComponent.jsx